import { escapeHtml, normalizeNewlines } from 'common/filters/utils'

export default function filterLinebreaksBr(text: string, isAutoescape: boolean = true) {
  let output = normalizeNewlines(text)

  if (isAutoescape) {
    output = escapeHtml(output)
  }

  return output.replace(/\n/g, '<br>')
}
